import { createStyles, Theme, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        iconButton: {
            height: 30,
            width: 30,
            padding: 0,
        },
        iconButtonIcon: {
            height: 25,
            width: 25,
        },
    })
);
